import { Col, Icon, IconName, Row, TextBody } from "../lib";

type Props = {
  content: string[];
  icon?: IconName;
  ordered?: boolean;
};

export function BulletList({
  content,
  icon = "minus",
  ordered = false,
}: Props) {
  return (
    <>
      {content.map((text, index) => (
        <Row.L mb="2" key={text}>
          <Col mr="2">
            {ordered ? (
              <TextBody>{index + 1}.</TextBody>
            ) : (
              <Icon name={icon} em />
            )}
          </Col>
          <TextBody>{text}</TextBody>
        </Row.L>
      ))}
    </>
  );
}
